module.exports = __webpack_public_path__ + "img/wzft_1_hover.6bc913af.jpg";